import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => {

  return {
    drawer: {
      width: theme.sizes.drawer.mobileWidth,
      [theme.breakpoints.up("md")]: {
        width: theme.sizes.drawer.desktopWidth,
        flexShrink: 0
      }
    },
    drawerPaper: {
      width: theme.sizes.drawer.mobileWidth,
      [theme.breakpoints.up("md")]: {
        width: theme.sizes.drawer.desktopWidth,
      },
      borderRight: 0,
      zIndex: 0,
      position: "fixed"
    },
  }
});

export default useStyles;